import { useCallback, useEffect, useState } from "react";
import { client, repository } from "~/clientInstance";
type FirstDeploymentStatus = {
    HasBeenSuccessfullyDeployed: boolean;
    SpaceHasSuccessfulDeployments: boolean;
};
export function useFirstDeploymentStatus(spaceId: string, projectSlug: string): boolean {
    const [initialProjectStatus, setInitialProjectStatus] = useState<FirstDeploymentStatus>();
    const [updatedProjectStatus, setUpdatedProjectStatus] = useState<FirstDeploymentStatus>();
    const getProjectStatus = useCallback(async (spaceId: string, projectSlug: string) => {
        const projectStatusFromServer = await repository.Projects.getProjectStatus(projectSlug, spaceId);
        return projectStatusFromServer;
    }, []);
    useEffect(() => {
        const getInitialState = async (spaceId: string, projectSlug: string) => {
            const { HasBeenSuccessfullyDeployed, SpaceHasSuccessfulDeployments } = await getProjectStatus(spaceId, projectSlug);
            setInitialProjectStatus({
                HasBeenSuccessfullyDeployed,
                SpaceHasSuccessfulDeployments,
            });
        };
        getInitialState(spaceId, projectSlug);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        return client.subscribe(async (event) => {
            if (event.type === "ReleaseProgressionModified") {
                const { HasBeenSuccessfullyDeployed, SpaceHasSuccessfulDeployments } = await getProjectStatus(spaceId, projectSlug);
                if (initialProjectStatus === undefined) {
                    setInitialProjectStatus({ HasBeenSuccessfullyDeployed, SpaceHasSuccessfulDeployments });
                }
                else {
                    setUpdatedProjectStatus({ HasBeenSuccessfullyDeployed, SpaceHasSuccessfulDeployments });
                }
            }
        });
    }, [getProjectStatus, initialProjectStatus, projectSlug, spaceId]);
    if (initialProjectStatus?.SpaceHasSuccessfulDeployments === false && initialProjectStatus?.HasBeenSuccessfullyDeployed === false && updatedProjectStatus?.HasBeenSuccessfullyDeployed === true) {
        return true;
    }
    return false;
}
